import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__generation_start } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_start';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_start_with_new_seeds = createAsyncThunkSafe<string, DTO_REQUEST__generation_start>(
  ENUM__network_event_client_to_server.GENERATION_START_WITH_NEW_SEEDS,
  async (request): Promise<string> => {
    await send_to_server(ENUM__network_event_client_to_server.GENERATION_START_WITH_NEW_SEEDS, request);

    return request.generation_id;
  },
);

export function INIT_REMOTE__generation_start_with_new_seeds(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_start_with_new_seeds.pending, (state, action) => {})
    .addCase(REMOTE__generation_start_with_new_seeds.rejected, (state, action) => {})
    .addCase(REMOTE__generation_start_with_new_seeds.fulfilled, (state, action: PayloadAction<string>) => {});
}
